<template lang="pug">
  .cp-top-bar.fix(@mouseleave="onMouseLeave")
    router-link.imgWrap.fl(to="/")
      img(src="../assets/logo.svg")
    .menu.fr
      .link-wrap(v-for="(v, index) in menuList", :key="v.path", @mouseenter="onMouseEnter(index)")
        a(v-if="v.meta.href", :href="v.meta.href", target="_blank") {{v.meta.title}}
        router-link(v-else, :to="v.path", active-class="activeRouter", ) {{ v.meta.title }}
          .arrow-wrap(v-if="v.children", :class="currentIndex !== index ? '': 'arrow-up'")
            .menu-arrow-down
    transition(name="subMenu")
      .subMenu(v-if="showSubMenu", :key="currentIndex")
        .subMenu-box.w
          .subMenu-item(
            v-for="v1 in currentMenu.children",
            v-if="!v1.meta.hideInMenu",
            :style="currentMenu.children.length < 3 ? 'flex-basis: calc(100% / 2)' : 'flex-basis: calc(100% / 3)'"
          )
            a.sub-link-wrap(v-if="v1.meta.href", :href="v1.meta.href", target="_blank")
              img.icon.fl(v-if="v1.meta.icon", :src="v1.meta.icon")
              .right
                .row1
                  span {{ v1.meta.title }}
                  icon.more(iconClass="icongengduo")
                .row2
                  span {{ v1.meta.detail }}
            router-link.sub-link-wrap(
              v-else
              :to="`${currentMenu.path}/${v1.path}`",
              :key="v1.path"
              tag="div",
              active-class="activeSubRouter"
            )
              img.icon.fl(v-if="v1.meta.icon", :src="v1.meta.icon")
              .right
                .row1
                  span {{ v1.meta.title }}
                  icon.more(iconClass="icongengduo")
                .row2
                  span {{ v1.meta.detail }}
  </template>
<script>
import { menuList } from '@/router/config'
import { isProd } from '@/common/utils.js'

export default {
  components: {},
  props: {},
  data () {
    return {
      menuList,
      currentIndex: -1,
    }
  },
  computed: {
    currentMenu () {
      return menuList[this.currentIndex]
    },
    showSubMenu () {
      return this.currentMenu && this.currentMenu.children
    },
    mpSrc () {
      return isProd ? 'https://mp.callai.net' : 'https://mptest.callaitest.cn'
    }
  },
  methods: {
    changeBgOpacity (percent) {
      const topbar = document.getElementsByClassName('cp-top-bar')[0]
      topbar.style.background = `rgba(0,7,38,${percent})`
    },
    onMouseEnter (index) {
      this.currentIndex = index
    },
    onMouseLeave () {
      this.currentIndex = -1
    },
    showModal () {
      this.$emit('showModal', true)
    }
  }
}
</script>
  <style lang="stylus">
  @import 'config'
  .cp-top-bar
    position fixed
    top 0px
    width 100%
    min-width $min-width
    z-index 100
    height $topbar-height
    background rgba(0,7,38,0.8)
    transition all .3s
    &:hover
      background rgba(0,7,38,1)
    .imgWrap
      margin-top 27px
      margin-left 108px
      img
        width 170px
        height 40px
    .menu
      margin-top 38px
      margin-right 100px
      a
        font-size 14px
        font-weight 500
        color #62F2FF
      .link-wrap
        display inline-block
        cursor pointer
        margin-right 50px
        &:hover
          a
            color #FFF
        a
          color #808695
          transition all .3s
        .activeRouter
          color #FFF
        .arrow-wrap
          position relative
          width 10px
          height 10px
          margin-left 5px
          display inline-block
          vertical-align middle
          transform-origin center
          transform rotate(0deg)
          transition all .3s
          .menu-arrow-down
            position absolute
            top 3px
            left 0px
        .arrow-up
          transform rotate(180deg)
          .menu-arrow-down
            border-top-color rgba(98,242,255,1)
      .load
        margin-right 30px
        transition all .3s
        &:hover
          color #98f3fb
      .btn
        display inline-block
        width 150px
        height 48px
        line-height 48px
        border 2px solid #62F2FF
        border-radius 8px
        text-align center
        color #62F2FF
        font-size 14px
        font-weight bold
        cursor pointer
        transition all .3s
        &:hover
          background rgba(98, 242, 255, .4)
    .subMenu
      position absolute
      top $topbar-height
      width 100%
      background rgba(0,7,38,1)

      .subMenu-box
        padding 35px 20px 0px
        display flex
        flex-wrap wrap
        .subMenu-item
          transition all 0.5s ease
          margin-bottom: 60px
          for num in (0..5)
            &:nth-child({num+1})
              transition-delay .1s * num
        .activeSubRouter
          .row1
            span
              color #9eeafa
        .sub-link-wrap
          cursor pointer
          img
            transform rotate(0deg)
            transition all .3s
          &:hover
            .row1
              span
                color #9eeafa
            img
              transform rotate(15deg)
          .icon
            width 60px
            height 60px
          .right
            position relative
            width 260px
            padding-left 20px
            overflow hidden
            .row1
              margin-bottom 10px
              span
                font-size 16px
              .more
                margin-left 20px
            .row2 span
              color rgba(255, 255, 255, 0.5)
    .subMenu-enter-active
      .subMenu-item
        opacity 1
        transform translate3d(0,0,0)
    .subMenu-enter
      .subMenu-item
        opacity 0
        transform translate3d(0,-50px,0)
  </style>
